import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextArea } from 'carbon-components-react';

export default class TextAreaField extends Component {
    render() {
        const { label, description, errors, ...other } = this.props,
            helperText = description && description() ? description() : false;

        return (
            <div className='ht-field ht-textfield'>
                <TextArea
                    labelText={label}
                    helperText={helperText}
                    invalid={!!errors}
                    invalidText={errors}
                    {...other}
                />
            </div>
        );
    }
}

TextAreaField.defaultProps = {
    description: null,
    label: '',
    value: ''
};

TextAreaField.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.func,
    label: PropTypes.string,
    value: PropTypes.string
};
